import { getClassLevel } from "../shared/getClassLevel";
import { evaluateSneakAttack } from "./sneakAttack";
import { evaluateEvasion } from "../../../../shared/rules/effects/saveDamageResolution.mjs";

const rogueAdapter = Object.freeze({
  id: "rogue",
  getClassLevel: (character) => getClassLevel(character, "rogue"),
  evaluateOnHit(context, queries) {
    return evaluateSneakAttack({
      rogueLevel: getClassLevel(context?.attacker?.entity, "rogue"),
      context,
      queries,
    });
  },
  modifyIncomingDamage(context, queries) {
    return evaluateEvasion(context, { character: context?.target?.entity, activeEffects: queries?.activeEffects || [] });
  },
});

export default rogueAdapter;
